(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 1150px)';
  var SOLID_CLASS = 'custom_header--footer-solid';
  var FOOTER_SELECTOR = '.shopify-section-group-footer-group';

  function initFooterSolid(root) {
    var el = (root || document).querySelector('hdt-sticky-header[data-custom-footer-solid]');
    if (!el || el.dataset.customFooterSolidBound === '1') return;

    var wrapper = el.closest('.hdt-section-header');
    if (!wrapper) return;

    el.dataset.customFooterSolidBound = '1';

    var devices = el.getAttribute('data-custom-footer-solid-devices') || 'both';
    var offset = parseInt(el.getAttribute('data-custom-footer-solid-offset'), 10);
    if (isNaN(offset)) offset = 0;

    var mql = window.matchMedia(DESKTOP_MQ);
    var ticking = false;
    var footer = null;
    var sizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

    /* The footer node is replaced on every theme-editor re-render, so the cached
       reference is revalidated instead of resolved once. */
    function getFooter() {
      if (!footer || !footer.isConnected) {
        footer = document.querySelector(FOOTER_SELECTOR);
        if (footer && sizeObserver) {
          sizeObserver.disconnect();
          sizeObserver.observe(footer);
        }
      }
      return footer;
    }

    function deviceMatches() {
      if (devices === 'both') return true;
      return devices === 'desktop' ? mql.matches : !mql.matches;
    }

    function update() {
      ticking = false;

      var target = getFooter();
      if (!target || !deviceMatches()) {
        wrapper.classList.remove(SOLID_CLASS);
        return;
      }

      var trigger = el.offsetHeight + offset;
      wrapper.classList.toggle(SOLID_CLASS, target.getBoundingClientRect().top <= trigger);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (mql.addEventListener) mql.addEventListener('change', schedule);
    else if (mql.addListener) mql.addListener(schedule);

    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFooterSolid(); });
  } else {
    initFooterSolid();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initFooterSolid(e.target);
  });
})();
